/**
 * This helper exists so we can test portal-vue wormhole content in unit tests.
 * Portal-vue absolutely refuses to accept a mock on "getContentForTarget", so we use this as a workaround.
 */
import { Wormhole } from 'portal-vue'

export function getWormholeContent(targetId) {
  return Wormhole.getContentForTarget(targetId)
}

